import dayjs from "dayjs";

/**
 * Centralized date formatting utilities
 * Standard formats:
 * - Date only: "May 14, 2025"
 * - Date with time: "May 14, 2025 - 11:01 PM"
 */

export const formatDate = (date, includeTime = false) => {
  if (!date) return 'N/A';
  
  try {
    const dayjsDate = dayjs(date);
    if (!dayjsDate.isValid()) return 'N/A';
    
    if (includeTime) {
      return dayjsDate.format("MMM DD, YYYY - hh:mm A");
    } else {
      return dayjsDate.format("MMM DD, YYYY");
    }
  } catch (error) {
    console.warn('Error formatting date:', error);
    return 'N/A';
  }
};

// Specific formatters for common use cases
export const formatDateOnly = (date) => formatDate(date, false);
export const formatDateTime = (date) => formatDate(date, true);

// For backwards compatibility and specific cases
export const formatCreatedAt = (date) => formatDateTime(date);
export const formatUpdatedAt = (date) => formatDateTime(date);
export const formatTimestamp = (date) => formatDateTime(date);

// For transaction dates (typically date only)
export const formatTransactionDate = (date) => formatDateOnly(date);

// For member dates (join date, retirement date, etc.)
export const formatMemberDate = (date) => formatDateOnly(date);

// For document/report dates
export const formatReportDate = (date) => formatDateOnly(date);

const dateFormatter = {
  formatDate,
  formatDateOnly,
  formatDateTime,
  formatCreatedAt,
  formatUpdatedAt,
  formatTimestamp,
  formatTransactionDate,
  formatMemberDate,
  formatReportDate
};

export default dateFormatter;
